// extracted by mini-css-extract-plugin
export default {"TanklessMobileCatalogFilterChoices":"styles_TanklessMobileCatalogFilterChoices__vyuAk","TanklessMobileCatalogFilter":"styles_TanklessMobileCatalogFilter__SXiOF"};